import React, { Suspense } from 'react';
import { isBrowser } from '@landr/maestro';

export const DynamicIcon: React.FC<{ iconName?: string }> = ({ iconName }) => {
    const Icon = React.lazy(() =>
        import('@landr/maestro').then((module) => {
            if (!iconName || !(iconName in module)) {
                iconName = 'BlocksOutlined';
            }
            return {
                default: module[iconName],
            };
        }),
    );

    return isBrowser ? (
        <Suspense fallback={null}>
            <Icon size="sm" />
        </Suspense>
    ) : null;
};
